import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { OrderService } from "@services/order.service";

const queryFor = (accessKey?: string) => accessKey?.length ? { accessKey } : {};

export const hasInFlightOrderGuard: CanActivateFn = async () => {
    const orderService = inject(OrderService);
    const router = inject(Router);

    await orderService.rehydrationReady;

    const phase = orderService.routingPhase();
    const order = orderService.order();
    const method = orderService.paymentMethod();
    const queryParams = queryFor(order?.temporaryAccessKey);

    // Defense in depth: if rehydration failed to classify (e.g. status groups
    // couldn't load) but there's still an order+method in storage, treat it as
    // a resume rather than letting the user roam free and double-order.
    if (phase === 'none' && order && method) {
        const path = method === 'Cash' ? '/checkout/cash-resume' : '/checkout/paymongo-resume';
        return router.createUrlTree([path], { queryParams });
    }

    switch (phase) {
        case 'none':
            return true;
        case 'stale':
            await orderService.clearStoredOrder();
            return router.createUrlTree(['/']);
        case 'terminal': {
            const terminalOrderId = order?.id;
            await orderService.clearStoredOrder();
            return router.createUrlTree(['/order-history', terminalOrderId], { queryParams });
        }
        case 'inFlight':
            return router.createUrlTree(['/order-history', order!.id], { queryParams });
        case 'resume': {
            const path = method === 'Cash' ? '/checkout/cash-resume' : '/checkout/paymongo-resume';
            return router.createUrlTree([path], { queryParams });
        }
    }
};
